import { Attr, HasMany, Model } from 'spraypaint';
import { Lot } from '..';
import ApplicationRecord from '../ApplicationRecord';

@Model()
export default class ArrivingDepartingGraph extends ApplicationRecord {
  static jsonapiType = 'arrival-departure-graphs';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
    ];
  }

  static scopeFactory() {
    return ArrivingDepartingGraph.includes([]);
  }

  @Attr() startDatetime: string;
  @Attr() endDatetime: string;
  @Attr() labels: [];
  @Attr() values: { departure: []; arrival: [] };

  @HasMany() lots: Lot[];
}
